module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /payu/microservice/multichannelportal/src/vendor/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/vendor/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = styles